/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import styled from "styled-components";
import { Heading22 } from "components/shared/Heading";
import { Text18 } from "components/shared/Text";
import desktopIllustration from "images/desktop-illustration.svg";
import { devices } from "components/shared/Styles";
import { BROWSER_ENFORCEMENT_Z_INDEX } from "components/Studio/ProjectContent/constants";

const Background = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  background-color: var(--spectrum-semantic-cta-background-color-default);
  display: flex;
  justify-content: center;
  overflow: scroll;
  height: 100%;
  z-index: ${BROWSER_ENFORCEMENT_Z_INDEX};
`;

const Content = styled.div`
  position: relative;
  top: 200px;
  height: 500px;
  width: 340px;
  border-radius: 16px;
  overflow: hidden;
  background-color: var(--spectrum-global-color-static-gray-300);

  ${devices.small} {
    top: 100px;
  }
`;

const Illustration = styled.div`
  position: absolute;
  top: 0px;
  height: 255px;
  width: 100%;
  background-image: url("${desktopIllustration}");
  background-color: var(--spectrum-global-color-static-gray-300);
  background-position: center;
  background-repeat: no-repeat;
`;

const MessageContainer = styled.div`
  position: absolute;
  bottom: 0px;
  height: 190px;
  width: 100%;
  background-color: var(--spectrum-global-color-static-white);
`;

const Message = styled.div`
  width: 244px;
  margin: 48px;
`;

const DesktopEnforcementPage: React.FC = () => {
  return (
    <Background>
      <Content>
        <Illustration data-testid="desktop-illustration" />
        <MessageContainer>
          <Message>
            <Heading22>
              {I18n.t("desktop_enforcement_miccheck.heading")}
            </Heading22>
            <Text18>{I18n.t("desktop_enforcement_miccheck.body")}</Text18>
          </Message>
        </MessageContainer>
      </Content>
    </Background>
  );
};

export default DesktopEnforcementPage;
